/**
 * ClickAir motion v2 — careful, few targets, layout-safe.
 * - Gated behind html.ca-m-on so content stays visible if JS fails
 * - Opacity-only on most nodes; tiny rise only on text/CTA blocks
 * - Never touches media stacks or sections that already use transform
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  // Text / CTA blocks only (single units, not children of complex layouts)
  var RISE = [
    '.clickair-statement__heading-wrap',
    '.clickair-portable__left',
    '.ca-pf__content',
    '.ca-wl__panel',
    '.ca-ch__inner',
    '.ca-cb__text',
    '.ca-ts__title',
    '.ca-ah__copy',
    '.ca-av__copy',
    '.ca-as__heading-wrap',
    '.ca-rp__title'
  ];

  // Discrete cards — opacity only (no transform; avoids fighting hover/layout)
  var FADE = [
    '.ca-pg__card',
    '.ca-pf__card',
    '.ca-apl__block',
    '.ca-ccc__card',
    '.ca-ts__card',
    '.ca-ap__grid > *'
  ];

  function getScrollRoot() {
    return window.matchMedia('(min-width: 990px)').matches
      ? document.querySelector('.page-wrapper')
      : null;
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.95 && r.bottom > 0;
  }

  function markAll() {
    RISE.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.classList.contains('ca-m')) return;
        el.classList.add('ca-m', 'ca-m--rise');
        if (inView(el)) el.classList.add('is-in');
      });
    });

    FADE.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.classList.contains('ca-m')) return;
        el.classList.add('ca-m');
        if (inView(el)) el.classList.add('is-in');
      });
    });

    // Primary CTAs not already inside a rise block
    document.querySelectorAll('.clickair-btn').forEach(function (btn) {
      if (btn.classList.contains('ca-m') || btn.closest('.ca-m--rise')) return;
      btn.classList.add('ca-m', 'ca-m--rise');
      if (inView(btn)) btn.classList.add('is-in');
    });
  }

  function observe() {
    var pending = document.querySelectorAll('.ca-m:not(.is-in)');
    if (!pending.length) return;

    if (!('IntersectionObserver' in window)) {
      pending.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      {
        root: getScrollRoot(),
        rootMargin: '0px 0px -4% 0px',
        threshold: 0.08
      }
    );

    pending.forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    markAll();
    // Enable CSS only after marks + in-view flags, same frame
    document.documentElement.classList.add('ca-m-on');
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
